import { rem } from 'polished';
import React from 'react';
import styled from 'styled-components';

import { Box, Spinner } from '@vimeo/bokeh';

export const MOBILE_MAX_WIDTH = 489;

export const Content = styled.div<{
  centered: boolean;
}>`
  height: ${rem(287)};
  overflow-y: auto;
  ${({ centered }) =>
    centered &&
    `
      overflow: hidden;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    `}
  @media screen and (max-width: ${MOBILE_MAX_WIDTH}px) {
    height: calc(100% - ${rem(78)}); // 78px is the height of the header and footer combined
  }
`;

export const Wrapper = styled.div<{
  unavailable?: boolean;
}>`
  position: relative;
  line-height: 1rem;

  ${({ unavailable }) =>
    unavailable &&
    `
      opacity: 0.5;

      &:hover {
        cursor: auto;
      }
    `}
`;

export const ScrollingLoader = () => (
  <Box display="flex" justifyContent="center" margin="10px auto">
    <Spinner variant="primary" />
  </Box>
);
